module.exports = __webpack_public_path__ + "img/fq_step1.c1216b29.png";